import React, { useState, useEffect } from "react";
import Button from "../../buttons/Button";
import { useLanguageContext } from "../../../context/languageContext";
import enUS from "../../../data/en-US";

const DirectorySection = () => {
    const { language } = useLanguageContext();
    const [ data, setData ] = useState();
    const info = {
        'en-US': enUS
    }
    useEffect(() => {
        setData(info[language].homepage.directory)
    })

    return (

        <div className="directory-section-wrapper font-face-poppins">
            <div className="themesflat-container">
                <div className="directory-section-title font-face-pop text-center">
                    { data && data.heading }
                </div>
                <div className="directory-section-body text-center">
                    { data && data.body }
                </div>
                <div className="directory-section-footer">
                    <div className="directory-categories-wrapper">
                        {
                            data && data.footer.icons.map((item, index) => (
                                <div className="directory-category" key={index}>
                                    <img src={ item.icon } alt={ item.name } />
                                    <span>{ item.name }</span>
                                </div>
                            ))
                        }
                    </div>
                    <div className="text-center">
                        <Button 
                            text={ data && data.footer.button }
                            width={274}
                            height={48}
                            borderRadius={10}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DirectorySection;